import styled from "styled-components"
import { minWidth, maxWidth } from "utils"
import CloudinaryImage from "components/cloudinary-image"
import { Link } from "gatsby"

export const Container = styled.div`
  width: 100%;
  margin: 0 auto 4rem auto;
  padding: 1.5rem 0;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  ${minWidth.mobileS`
    padding: 2rem 0;
    gap: 2rem;
  `}

  ${minWidth.mobile`
    gap: 2rem;
  `}

  ${minWidth.tablet`
    flex-direction: row;
    gap: 3rem;
    padding: 3rem 0;
  `}

  ${minWidth.desktop`
    gap: 4rem;
    padding: 4rem 0;
  `}

  ${minWidth.desktopL`
    gap: 4.5rem;
  `}

  ${minWidth.desktopXL`
    gap: 5rem;
  `}
`

export const FeaturedSection = styled.div`
  flex: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  ${minWidth.mobileS`
    gap: 0.9rem;
  `}

  ${minWidth.mobile`
    gap: 1rem;
  `}

  ${minWidth.tablet`
    flex: 0 0 50%;
    width: 100%;
    gap: 1.2rem;
  `}

  ${minWidth.tabletLow`
    flex: 0 0 48%;
    width: 48%;
    gap: 1.3rem;
  `}

  ${minWidth.desktop`
    flex: 0 0 45%;
    width: 45%;
    gap: 1.5rem;
  `}

  ${minWidth.rightRail`
    flex: 0 0 45%;
    width: 45%;
    gap: 1.6rem;
  `}

  ${minWidth.desktopL`
    flex: 0 0 45%;
    width: 45%;
    gap: 1.8rem;
  `}

  ${minWidth.desktopXL`
    flex: 0 0 45%;
    width: 45%;
    gap: 2rem;
  `}

  ${minWidth.desktopXXL`
    flex: 0 0 45%;
    width: 45%;
    gap: 2.2rem;
  `}
`

export const FeaturedImage = styled(CloudinaryImage)`
  width: 100%;
  height: 18rem;
  overflow: hidden;
  background-color: #d9d9d9;
  border-radius: 0.5rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${minWidth.mobileS`
    height: 20rem;
  `}

  ${minWidth.mobile`
    height: 22rem;
  `}

  ${minWidth.tablet`
    height: 25rem;
    border-radius: 1rem;
  `}

  ${minWidth.tabletLow`
    height: 26rem;
  `}

  ${minWidth.desktop`
    height: 28rem;
  `}

  ${minWidth.rightRail`
    height: 30rem;
  `}

  ${minWidth.desktopL`
    height: 32rem;
  `}

  ${minWidth.desktopXL`
    height: 33.3rem;
  `}

  ${minWidth.desktopXXL`
    height: 35rem;
  `}
`

export const FeaturedContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  ${minWidth.mobileS`
    gap: 1rem;
  `}

  ${minWidth.mobile`
    gap: 1.2rem;
  `}

  ${minWidth.tablet`
    gap: 1.3rem;
  `}

  ${minWidth.tabletLow`
    gap: 1.4rem;
  `}

  ${minWidth.desktop`
    gap: 1.5rem;
  `}

  ${minWidth.rightRail`
    gap: 1.6rem;
  `}

  ${minWidth.desktopL`
    gap: 1.8rem;
  `}

  ${minWidth.desktopXL`
    gap: 2rem;
  `}
`

export const CategoryText = styled.div`
  color: #2260b2;
  text-shadow: 0.1rem 0.1rem 0.1rem rgba(0, 0, 0, 0);
  font-family: Maax;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.2rem;
  text-transform: uppercase;

  ${minWidth.mobileS`
    font-size: 1rem;
  `}

  ${minWidth.mobile`
    font-size: 1.1rem;
  `}

  ${minWidth.tablet`
    font-size: 1.2rem;
  `}

  /* Hide category text on smaller screens */
  ${maxWidth.mobile`
    display: none;
  `}
`

export const FeaturedTitle = styled.h2`
  color: ${({ theme }) => theme.colors.text.primary};
  text-shadow: 0.1rem 0.1rem 0.1rem rgba(0, 0, 0, 0);
  font-family: Maax;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.2rem;
  margin: 0;

  ${minWidth.mobileS`
    font-size: 1.9rem;
    line-height: 2.3rem;
  `}

  ${minWidth.mobile`
    font-size: 2rem;
    line-height: 2.4rem;
  `}

  ${minWidth.tablet`
    font-size: 2.2rem;
    line-height: 2.6rem;
  `}

  ${minWidth.tabletLow`
    font-size: 2.4rem;
    line-height: 2.8rem;
  `}

  ${minWidth.desktop`
    font-size: 2.6rem;
    line-height: 3rem;
  `}

  ${minWidth.rightRail`
    font-size: 2.8rem;
    line-height: 3.2rem;
  `}

  ${minWidth.desktopL`
    font-size: 3rem;
    line-height: 3.4rem;
  `}

  ${minWidth.desktopXL`
    font-size: 3rem;
    line-height: 3.4rem;
  `}

  ${minWidth.desktopXXL`
    font-size: 3rem;
    line-height: 3.4rem;
  `}
`

export const FeaturedAuthor = styled.p`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 400;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  letter-spacing: 0;
  text-transform: capitalize;
  margin: 0;

  ${minWidth.desktop`
    font-size: 1.4rem;
    line-height: 1.3rem;
  `}
`

export const ArticlesSection = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
  margin-top: 2rem;
  height: fit-content;

  /* Hide scrollbar */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  ${minWidth.tablet`
    margin-top: 0;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.8rem;
  `}

  ${minWidth.desktop`
    gap: 2.2rem;
  `}

  ${minWidth.desktopL`
    gap: 2.5rem;
  `}

  ${minWidth.desktopXL`
    gap: 2.8rem;
  `}

  ${minWidth.desktopXXL`
    gap: 3.2rem;
  `}


  /* Horizontal scrolling for smaller screens using maxWidth utils */
  ${maxWidth.tabletLow`
    margin-top: 2rem;
    flex: none;
    width: 100%;
    display: -webkit-box;
    overflow-x: auto;
    padding-bottom: 1rem;
    scroll-snap-type: x mandatory;
  `}
`

export const ArticleCardWrapper = styled.div`
  border-radius: 0;
  width: 100%;
  padding: 1.2rem 0;

  ${minWidth.mobile`
    padding-top: 1.2rem;
    padding-bottom: 1.4rem;
  `}

  ${minWidth.tablet`
    padding-top: 0;
    padding-bottom: 1.5rem;
  `}

  ${minWidth.desktop`
    padding-bottom: 1.8rem;
  `}

  ${minWidth.desktopL`
    padding-bottom: 2rem;
  `}

  ${minWidth.rightRail`
    padding-bottom: 2rem;
  `}


  /* Horizontal scroll styling for smaller screens using maxWidth utils */
  ${maxWidth.mobile`
    border-top: 0.1rem solid #00000040;
    width: 17rem;
    flex: 0 0 17rem;
    scroll-snap-align: start;
    margin-right: 3rem;
  `}

  ${maxWidth.tabletLow`
    border-top: 0.1rem solid #00000040;
    width: 20rem;
    flex: 0 0 20rem;
    scroll-snap-align: start;
    margin-right: 4rem;
  `}
`

export const ArticleCard = styled.div`
  padding: 1.2rem;
  border-radius: 0;
  transition: all 0.3s ease;
  width: 100%;

  ${minWidth.mobileS`
    padding: 1.3rem;
  `}

  ${minWidth.mobile`
    padding: 1.4rem;
  `}

  ${minWidth.tablet`
    padding: 1.5rem;
  `}

  ${minWidth.tabletLow`
    padding: 1.6rem;
  `}

  ${minWidth.desktop`
    padding: 1.8rem;
  `}

  ${minWidth.rightRail`
    padding: 2rem;
  `}

  ${minWidth.desktopL`
    padding: 2.2rem;
  `}

  ${minWidth.desktopXL`
    padding: 2.5rem;
  `}

  ${minWidth.desktopXXL`
    padding: 2.8rem;
  `}
`

export const ButtonSection = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;

  ${minWidth.mobileS`
    margin-top: 1.8rem;
  `}

  ${minWidth.mobile`
    margin-top: 2rem;
  `}

  ${minWidth.tablet`
    margin-top: 2.5rem;
  `}

  ${minWidth.tabletLow`
    margin-top: 3rem;
  `}

  ${minWidth.desktop`
    margin-bottom: 4rem;
    margin-top: 3.5rem;
  `}

  ${minWidth.rightRail`
    margin-bottom: 4rem;
    margin-top: 4rem;
  `}

  ${minWidth.desktopL`
    margin-bottom: 6rem;
    margin-top: 4.5rem;
  `}

  ${minWidth.desktopXL`
    margin-bottom: 8rem;
    margin-top: 5rem;
  `}
`

export const MoreArticlesButton = styled.button`
  background: #12233f;
  color: #ffffff;
  border: none;
  padding: 0.8rem 1.8rem;
  font-size: 1.1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  border-radius: 2.5rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #1a2f4f;
    transform: translateY(-0.2rem);
  }

  ${minWidth.mobileS`
    padding: 0.9rem 2rem;
    font-size: 1.2rem;
  `}

  ${minWidth.mobile`
    padding: 1rem 2.2rem;
    font-size: 1.3rem;
  `}

  ${minWidth.tablet`
    padding: 1.1rem 2.5rem;
    font-size: 1.4rem;
  `}

  ${minWidth.tabletLow`
    padding: 1.2rem 2.8rem;
    font-size: 1.5rem;
  `}

  ${minWidth.desktop`
    padding: 1.3rem 3rem;
    font-size: 1.6rem;
  `}

  ${minWidth.rightRail`
    padding: 1.4rem 3.2rem;
    font-size: 1.7rem;
  `}

  ${minWidth.desktopL`
    padding: 1.5rem 3.5rem;
    font-size: 1.8rem;
  `}

  ${minWidth.desktopXL`
    padding: 1.6rem 3.8rem;
    font-size: 1.9rem;
  `}

  ${minWidth.desktopXXL`
    padding: 1.7rem 4rem;
    font-size: 2rem;
  `}
`

export const HomepageTabbedButton = styled.button`
  background: #12233f;
  color: #ffffff;
  border: none;
  padding: 0.5rem 1.4rem;
  font-family: Maax;
  font-size: 1.1rem;
  font-weight: 500;
  font-style: normal;
  line-height: 1.5rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  text-align: center;
  border-radius: 2.5rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #1a2f4f;
    transform: translateY(-0.2rem);
  }

  ${minWidth.mobileS`
    padding: 0.6rem 1.6rem;
    font-size: 1.2rem;
    line-height: 1.6rem;
  `}

  ${minWidth.mobile`
    padding: 0.7rem 1.8rem;
    font-size: 1.3rem;
    line-height: 1.7rem;
  `}

  ${minWidth.tablet`
    padding: 0.8rem 2rem;
    font-size: 1.4rem;
    line-height: 1.89rem;
  `}

  ${minWidth.tabletLow`
    padding: 0.9rem 2.2rem;
    font-size: 1.5rem;
    line-height: 2rem;
  `}

  ${minWidth.desktop`
    padding: 1rem 2.4rem;
    font-size: 1.6rem;
    line-height: 2.1rem;
  `}

  ${minWidth.rightRail`
    padding: 1.1rem 2.6rem;
    font-size: 1.7rem;
    line-height: 2.2rem;
  `}

  ${minWidth.desktopL`
    padding: 1.2rem 2.8rem;
    font-size: 1.8rem;
    line-height: 2.3rem;
  `}

  ${minWidth.desktopXL`
    padding: 1.3rem 3rem;
    font-size: 1.9rem;
    line-height: 2.4rem;
  `}

  ${minWidth.desktopXXL`
    padding: 1.4rem 3.2rem;
    font-size: 2rem;
    line-height: 2.5rem;
  `}
`

export const LocalArticleHeadline = styled.h3`
  font-family: Maax;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 0.8rem 0;

  ${minWidth.mobileS`
    font-size: 1.3rem;
    margin: 0 0 0.9rem 0;
  `}

  ${minWidth.mobile`
    font-size: 1.4rem;
    margin: 0 0 1rem 0;
  `}

  ${minWidth.tablet`
    font-size: 1.5rem;
    margin: 0 0 1.1rem 0;
  `}

  ${minWidth.tabletLow`
    font-size: 1.6rem;
    margin: 0 0 1.2rem 0;
  `}

  ${minWidth.desktop`
    font-size: 1.7rem;
    margin: 0 0 1.3rem 0;
  `}

  ${minWidth.rightRail`
    font-size: 1.8rem;
    margin: 0 0 1.4rem 0;
  `}

  ${minWidth.desktopL`
    font-size: 1.9rem;
    margin: 0 0 1.5rem 0;
  `}

  ${minWidth.desktopXL`
    font-size: 1.9rem;
    margin: 0 0 1.6rem 0;
  `}

  ${minWidth.desktopXXL`
    font-size: 1.9rem;
    margin: 0 0 1.7rem 0;
  `}
`

export const LocalArticleByline = styled.div`
  font-family: Maax;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.text.primary};

  ${minWidth.desktopXXL`
    font-size: 1.4rem;
  `}
`

export const LocalArticleLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
`

export const StyledArticleLink = styled(Link)`
  ${maxWidth.mobile`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  `}
`
